// The width every Contact Center page may grow to. The pages were capped at
// 1,180-1,360px each, which on a wide monitor left a third of the screen
// empty at the sides. Their card and tile grids are all fluid (auto-fill /
// auto-fit), so a wider page adds columns rather than stretching them. The
// cap stays, so a very wide screen still reads as one page.
export const CC_PAGE_MAX_WIDTH = '1920px';
